export default __webpack_public_path__ + "static/media/select_coach_operator.988ff41f.png";